"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _FadeIn = require("@jobmatchme/ui/es/components/FadeIn");

var _JmmLoader = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/JmmLoader"));

var _reactI18next = require("react-i18next");

var _JobofferCard = _interopRequireDefault(require("./JobofferCard"));

var _OfferData = _interopRequireDefault(require("./OfferData"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The JobOffer Information
 * @param {status}  string  Shows the status of the current offer. notProcessed, like, dislike
 **/
var Joboffer = function Joboffer(props) {
  var index = props.index,
      preview = props.preview,
      _props$animation = props.animation,
      animation = _props$animation === void 0 ? false : _props$animation;
  var scrollerPath = 'offerDescription' + index;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var thisProps = {
    t: t,
    scrollerPath: scrollerPath
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: _styleModule.default.content,
    children: animation === 'loading' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FadeIn.SimpleFadeIn, {
      delay: 100,
      transition: 0.5,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JmmLoader.default, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _styleModule.default.joboffer,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "".concat(_styleModule.default.offerData, " ").concat(preview ? _styleModule.default.preview : ''),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_JobofferCard.default, (0, _extends2.default)({}, props, thisProps))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferData.default, (0, _extends2.default)({}, props, thisProps))]
    }, 'job' + index)
  });
};

var _default = (0, _withStyles.default)(_styleModule.default)(Joboffer);

exports.default = _default;